(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/modules/arena-react/assets/service/draws-processer.js') >= 0) return;  svs.modules.push('/modules/arena-react/assets/service/draws-processer.js');
'use strict';

function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
const getProducts = () => [{
  productId: [10, 11],
  productName: 'Lotto',
  branding: 'lotto',
  informativeTexts: [],
  urlMapping: 'lottoPlay',
  drawDays: 'Onsdag och lördag'
}, {
  productId: [29, 37],
  productName: 'Eurojackpot',
  branding: 'eurojackpot',
  informativeTexts: [],
  urlMapping: 'eurojackpotPlay',
  drawDays: 'Tisdag och fredag'
}, {
  productId: 9,
  productName: 'Keno',
  branding: 'keno',
  informativeTexts: ['Vinn upp till 20 miljoner'],
  urlMapping: 'kenoPlay',
  drawDays: 'Varje dag'
}, {
  productId: 14,
  productName: 'Vikinglotto',
  branding: 'vikinglotto',
  informativeTexts: [],
  urlMapping: 'vikinglottoPlay',
  drawDays: 'Onsdagar'
}, {
  productName: 'Rubbet',
  branding: 'rubbet',
  informativeTexts: [],
  drawDays: '',
  query: '&bag=rubbet_medium',
  url: "".concat(svs.core.urlMapping.get('rubbetHome'))
}];
const fixJackpots = productJackpots => {
  productJackpots.filter(Boolean).forEach(pJ => {
    let currentJackpot = 0;
    let guaranteedJackpot = 0;

    if (pJ.productId === 10 || pJ.productId === 11) {
      pJ.guaranteedJackpots = pJ.guaranteedJackpots.filter(Boolean)
      .filter(gJ => gJ.description !== 'Lotto 2');
    }

    switch (pJ.productName) {
      case 'Lotto':
        {
          var _pJ$guaranteedJackpot, _pJ$jackpots$find$jac, _pJ$jackpots$find;
          guaranteedJackpot = (_pJ$guaranteedJackpot = pJ.guaranteedJackpots.find(j => j.description === 'Drömvinsten')) === null || _pJ$guaranteedJackpot === void 0 ? void 0 : _pJ$guaranteedJackpot.jackpotAmountSek;
          currentJackpot = (_pJ$jackpots$find$jac = (_pJ$jackpots$find = pJ.jackpots.find(j => j.description === 'Drömvinsten')) === null || _pJ$jackpots$find === void 0 ? void 0 : _pJ$jackpots$find.jackpotAmount) !== null && _pJ$jackpots$find$jac !== void 0 ? _pJ$jackpots$find$jac : guaranteedJackpot;
          break;
        }
      case 'Eurojackpot':
        {
          var _pJ$guaranteedJackpot2, _pJ$jackpots$0$jackpo, _pJ$jackpots$;
          guaranteedJackpot = (_pJ$guaranteedJackpot2 = pJ.guaranteedJackpots[0]) === null || _pJ$guaranteedJackpot2 === void 0 ? void 0 : _pJ$guaranteedJackpot2.jackpotAmountSek;
          currentJackpot = (_pJ$jackpots$0$jackpo = (_pJ$jackpots$ = pJ.jackpots[0]) === null || _pJ$jackpots$ === void 0 ? void 0 : _pJ$jackpots$.jackpotAmount) !== null && _pJ$jackpots$0$jackpo !== void 0 ? _pJ$jackpots$0$jackpo : guaranteedJackpot;
          break;
        }
      case 'Vikinglotto':
        {
          var _pJ$jackpots$0$jackpo2, _pJ$jackpots$2, _pJ$guaranteedJackpot3;
          currentJackpot = (_pJ$jackpots$0$jackpo2 = (_pJ$jackpots$2 = pJ.jackpots[0]) === null || _pJ$jackpots$2 === void 0 ? void 0 : _pJ$jackpots$2.jackpotAmount) !== null && _pJ$jackpots$0$jackpo2 !== void 0 ? _pJ$jackpots$0$jackpo2 : (_pJ$guaranteedJackpot3 = pJ.guaranteedJackpots[0]) === null || _pJ$guaranteedJackpot3 === void 0 ? void 0 : _pJ$guaranteedJackpot3.jackpotAmountSek;
          break;
        }
      default:
    }
    const mergedJackpots = pJ.guaranteedJackpots;
    const guaranteedWinsets = pJ.guaranteedJackpots.reduce((acc, gJ) => [...acc, gJ.winset], []);
    pJ.jackpots.forEach(j => {
      const index = guaranteedWinsets.indexOf(j.winset);
      if (index > -1) {
        mergedJackpots[index] = j;
      } else {
        mergedJackpots.push(j);
      }
    });
    pJ.fixedJackpots = mergedJackpots.map(mJ => _objectSpread(_objectSpread({}, mJ), {}, {
      amount: Number((mJ.jackpotAmountSek || mJ.jackpotAmount).replace(',', '.')),
      extra: mJ.description === 'Lotto 1' || mJ.description === 'Lotto' ? 'Lotto 1 ' : '',
      rubbetJackpotAmount: parseInt(currentJackpot, 10) + parseInt(guaranteedJackpot, 10)
    }));
    pJ.fixedJackpots.sort((a, b) => b.amount - a.amount);
  });
};
const parseResponses = async responses => {
  const products = getProducts();
  products.forEach(product => {
    const url = product.url,
      urlMapping = product.urlMapping;
    product.urlMapping = url ? url : svs.core.urlMapping.get(urlMapping);
  });
  responses.forEach(res => {
    if (!res) {
      return;
    }
    if (res && Array.isArray(res.jackpots)) {
      res.jackpots = res.jackpots.filter(productJackpot => productJackpot.productId !== 9);
      fixJackpots(res.jackpots);
      const kenoMaxWin = 20000000;
      const jokerMaxWin = 10000000;
      const rubbetJackpot = res.jackpots.reduce((acc, jackpot) => {
        const productName = jackpot.productName;
        const jackpots = jackpot.fixedJackpots;
        const texts = [];
        let rubbetJackpotAmount = 0;
        jackpots.forEach(j => {
          let prefix = 'Jackpot ';
          if (j.description === 'Drömvinsten') {
            prefix = 'Drömvinsten ';
          }
          const numMillions = Math.round(j.amount / 1000000);
          texts.unshift({
            productName,
            text: "".concat(prefix).concat(j.extra, "ca ").concat(numMillions, " miljon").concat(numMillions > 1 ? 'er' : '', " kr")
          });
          rubbetJackpotAmount = j.rubbetJackpotAmount;
        });
        texts.forEach(t => {
          const product = _.find(products, p => p.productName === t.productName);
          if (product && product.productName !== 'Keno') {
            product.informativeTexts.push(t.text);
          }
        });
        return acc + rubbetJackpotAmount;
      }, kenoMaxWin + jokerMaxWin * 2);
      const rubbet = products.filter(product => /rubbet/i.test(product.productName));
      if (rubbet.length) {
        const numMillionsRubbet = Math.round(rubbetJackpot / 1000000);
        if (isNaN(numMillionsRubbet) || numMillionsRubbet === 0) {
          rubbet[0].informativeTexts.push('Rubbet - Flera miljonchanser i veckan');
        } else {
          rubbet[0].informativeTexts.push("Totala toppvinster just nu ca ".concat(numMillionsRubbet, " miljon").concat(numMillionsRubbet > 1 ? 'er' : '', " kr"));
        }
      }
    }
  });
  return products;
};
svs.arena.service.drawsProcesser = {
  parseResponses
};

 })(window);